<!--
 * @Description: 潜在客户完善资料
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-18 09:18:41
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :perfect="true" :permissionPage="permissionBasic" :disabled="false" :data="data" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      data.value = res.data
    })
  }
}
const permissionBasic = {
  save: 'ofbu_potential_perfect_btn',
  editCode: 'ofbu_perfect_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default { name: 'DcCosOFbuPotentialPerfect' }
</script>
<style lang="scss" scoped></style>
